import { Authorization } from '../../../model/authorization';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { AuthorizationService } from '../../../services/authorization.service';

@Component({
    selector: 'app-authorization-dialog',
    templateUrl: 'authorization-dialog.component.html',
  })
  export class AuthorizationDialogComponent implements OnInit {

    form: FormGroup;
    @ViewChild('pass', {static: false}) pass: ElementRef;

    constructor(
      public dialogRef: MatDialogRef<AuthorizationDialogComponent>
      , private authorizationService: AuthorizationService
      , private formBuilder: FormBuilder
      , private notificationToastService: NotificationToastService
      , @Inject(MAT_DIALOG_DATA) public data: Authorization) {
      this.form = this.formBuilder.group({
        Observations: [''],
        Password: ['', Validators.required],
      });
    }

    ngOnInit(): void {
     setTimeout(() => this.pass.nativeElement.focus(), 0);
    }

    get f() { return this.form.controls; }

    async onNoClick() {
      try {
        await this.authorizationService.authorizationCancel(this.data
          , this.form.value.Observations);
          this.dialogRef.close(false);
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Autorización');
      }
    }

    async authorize() {
      try {
        if (!this.form.invalid) {
            await this.authorizationService.authorize(this.data, this.form.value.Password
              , this.form.value.Observations);
            this.dialogRef.close(true);
          }
      } catch (err) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Autorización');
      }
    }
  }
